const snackBar = {
  state: {
    icon: 'fas fa-lock',
    status: false,
    color: 'primary',
    message: 'Testing'
  },
  mutations: {
    setSnackBar (state: any, payload: any) {
      state.icon = payload.icon
      state.status = payload.status
      state.color = payload.color
      state.message = payload.message
    }
  }
}

export default snackBar
